import CategoryPageRenderer from "@/components/CategoryPageRenderer";
export default function AktivitasJamaah() {
  return <CategoryPageRenderer pageKey="aktivitas-jamaah" />;
}
